module.exports = __webpack_public_path__ + "static/avatar-f7c94c751615047e5b8fa6566ac5e354.png";